<div class="flex h-screen overflow-hidden">
  <app-nav [hidden]="hideSidebar" (logoutClick)="logout()"></app-nav>
  <div class="flex-1 min-h-0 flex flex-col">
    @if (!hideSidebar) {
      <app-mobile-home-menu (logoutClick)="logout()"></app-mobile-home-menu>
    }
    <div class="flex-1 min-h-0 overflow-hidden">
      <router-outlet />
    </div>
  </div>
</div>
